import routerOptions0 from "/var/www/html/fullstack-saas/frontend/node_modules/.pnpm/nuxt@3.19.1_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@9.35.0_jiti_73c3980b6ddde6b6ae6d2a92255ef75b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}